import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import { filter, isNumber } from 'lodash'

import Highchart from '../../../../../Reports/Charts/charts/Highcharts'
import { colors } from '@lmc/common/constants'

const MedStockChart = ({
  medication,
  logs,
  startDate,
  endDate,
  yAxisLabel,
  testId
}) => {
  let data = []

  const { quantityType, stockQuantityType } = medication
  const showExpectedStock = quantityType === stockQuantityType

  filter(logs, { deleted: false }).forEach((log) => {
    const hasActualStock = isNumber(log.amount1)
    const hasExpectedStock = isNumber(log.amount2)
    const hasStockChanged =
      hasActualStock && hasExpectedStock && log.amount1 !== log.amount2
    if (hasActualStock) {
      // don't show the ticks if showExpectedStock === false
      data.push({
        x: Date.parse(dayjs(log.timeLogged).toString()),
        y: log.amount1,
        log,
        color: hasStockChanged ? colors.yellow : colors.blue,
        marker: {
          symbol: showExpectedStock
            ? hasStockChanged
              ? 'url(https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/alert-icon2.png)'
              : `url(https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/tick-icon.png)`
            : null,
          height: showExpectedStock && 18,
          width: showExpectedStock && 18,
          lineColor: hasStockChanged ? colors.yellow : colors.blue
        }
      })
    }

    if (hasExpectedStock && log.amount1 !== log.amount2) {
      data.push({
        log,
        // Hacking highcharts: if the time for two data points is the same it's not possible to hover
        x: Date.parse(dayjs(log.timeLogged).subtract(1, 's').toString()),
        y: log.amount2
      })
    }
  })

  return (
    <div data-testid={testId ? `${testId}-med-stock-chart` : 'med-stock-chart'}>
      <Highchart
        config={{
          yAxisLabel: `Stock Count ${
            medication.stockQuantityType
              ? `(${medication.stockQuantityType})`
              : ''
          }`,
          from: startDate,
          minX: Date.parse(dayjs(startDate).endOf('day').toString()),
          maxX: Date.parse(dayjs(endDate).endOf('day').toString()),
          // to: Date.parse(endDate.toString()),
          // subTitle: 'Bristol Stool Scale',
          // yAxisLabel: 'Number of bowel movements',
          // legendEnabled: true,
          // chartType: 'line',
          // xAxis: {
          //     type: 'datetime',
          //     title: {
          //         text: 'Date'
          //     },
          //     accessibility: {
          //         rangeDescription: ''
          //     }
          // },
          // yAllowDecimals: false,
          tooltip: {
            formatter: function (a) {
              const { log } = this.point
              return `<strong style="font-size: 12px; opacity: 0.6;">
                                    ${dayjs(this.x).format(
                                      'ddd Do MMM - HH:mm'
                                    )} - ${
                                      log?.loggedBy && log?.loggedBy.name.first
                                    } ${log?.loggedBy && log?.loggedBy.name.last}
                                </strong>
                                <br />
                                <b style="font-size: 16px; font-weight: 600;">${
                                  log.title
                                }</b><br />
                                ${log.description}<br />
                                ${
                                  log.amount1
                                    ? `<b style="font-size: 10px; opacity: 0.6;">${
                                        log.amount1
                                      } ${
                                        medication.stockQuantityType || ''
                                      } counted</b><br />`
                                    : ''
                                }
                                ${
                                  log.amount2
                                    ? `<b style="font-size: 10px; opacity: 0.6;">${
                                        log.amount2
                                      } ${
                                        medication.stockQuantityType || ''
                                      } expected</b><br />`
                                    : ''
                                }`
            },
            style: { width: '300px' }
          },
          series: [
            {
              name: 'Stock',
              data: data.sort((a, b) =>
                dayjs(a.log.timeLogged).diff(dayjs(b.log.timeLogged))
              ),
              color: colors.blue,
              marker: {
                lineColor: colors.blue,
                fillColor: 'white'
              }
            }
          ]
        }}
      />
    </div>
  )
}

export default MedStockChart

MedStockChart.propTypes = {
  logs: PropTypes.array.isRequired,
  testId: PropTypes.string
}
